import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'app/core/authentication/services';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class DefaultHttpOptionsInterceptor implements HttpInterceptor {

  constructor(private readonly _authService: AuthService) {}

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const httpOptions: any = {
      observe: 'response',
      responseType: 'json',
      withCredentials: true,
    };
    const clonedRequest: HttpRequest<any> = req.clone(httpOptions);

    // Pass the cloned request instead of the original request to the next handle
    return next.handle(clonedRequest).pipe(
      tap((event: HttpEvent<any>) => {}, (err: any) => {
        if (!(err instanceof HttpErrorResponse)) {
          return;
        }

        if (err.status === 401) {
          if (clonedRequest.url.includes('logout') || clonedRequest.url.includes('auth')) {
            return;
          }

          this._authService.logout();
        }
      }),
    );
  }
}
